const et = {
  generic: {
    actions: {
      scrollLeft: 'Keri vasakule',
      scrollRight: 'Keri paremale',
      goBack: 'Tagasi',
      close: 'Sulge',
      addBookmark: 'Salvesta',
      removeBookmark: 'Salvestatud järjehoidjatesse',
      showLess: 'Näita vähem',
      showMore: 'Näita rohkem',
      openPDF: 'Ava PDF fail',
      openMenu: 'Ava menüü',
      scrollToTop: 'Tagasi üles',
      listenTranscription: 'Kuula ariklit',
      share: 'Jaga',
      remove: 'Kustuta kõik',
      show: 'Näita',
      filter: 'Filtreeri',
      closeMessage: 'Sulge teade',
    },
  },
  components: {
    menu: {
      campaign: 'Kampaania!',
      servicesAndProducts: 'Teenused ja tooted',
      backgroundInformation: 'Ettevõtete ja juhtide taustainfo',
      debtRegister: 'Võlaregister',
      marketReview: 'Konkurentsiraportid',
      marketingLists: 'Turundusnimekirjad',
      salesAgent: 'Müügiagent',
      certificates: 'Sertifikaadid',
      api: 'Andmeliidesed',
      pricingPackages: 'Hinnapaketid',
      blog: 'Blogi',
      aboutUs: 'Meist',
      contact: 'Kontakt',
      termsOfService: 'Kasutustingimused',
      consultation: 'Soovid tasuta konsultatsiooni ja Infopanga demo?',
      booking: 'Broneeri demo',
    },
    intro: {
      title: 'Kõik Eesti ettevõtetest',
      creditInformation: 'Taustainfo',
      debtRegister: 'Võlaregister',
      marketingLists: 'Turundusnimekirjad',
      salesAgent: 'Müügiagent',
      marketReviews: 'Konkurentsiraportid',
      certificates: 'Sertifikaadid',
      dataIntegration: 'Andmeliidesed',
    },
    hero: {
      author: 'Autor',
      authors: 'Autorid',
    },
    search: {
      startSearch: 'Otsi',
      placeholder: 'Otsi ettevõtet või isikut',
      clearFields: 'Puhasta otsing',
      companies: 'Ettevõtted',
      persons: 'Isikud',
      all: 'Kõik',
      articles: 'Artiklid',
      result: ' otsingu tulemust',
      description:
        'NB! Kuvame tulemuses kuni 10000 kirjet. Palun täpsusta filtrite valikut. Faili läheb kuni 10000 kirjet. Palun täpsusta filtrite valikut. Andmete koosseis: isiku nimi, sünniaeg, sugu, isiku kontaktid, seotud ettevõtte nimi, registrikood, tegevusala, ettevõtte kontaktid, müügitulu, ärikasum ning töötajate arv',
      sendRequest: 'Saada päring',
      viewFileExample: 'Vaata näidist (.xlsx)',
      noPersonResults: '0 tulemust isikute otsingule {{query}} ... teosta uus otsing!',
      noCompanyResults: '0 tulemust ettevõte otsingule {{query}} ... teosta uus otsing!',
      companyName: 'Ettevõtte nimi',
      registrationCode: 'Reg. kood',
      headerResults: 'tulemust otsingule',
      backToSearch: 'Tagasi otsingutulemustele',
      formerName: 'endine nimi',
    },
    header: {
      login: 'Logi sisse',
      logout: 'Logi välja',
    },
    footer: {
      findUs: 'Leia meid {{label}}',
    },
    applicationForm: {
      title: 'Kandideerimisvorm',
      firstname: 'Eesnimi',
      surname: 'Perekonnanimi',
      phone: 'Telefon',
      email: 'E-mail',
      message: 'Sõnum (motivatsioonikiri)',
      addCv: 'Lisa CV (docx, PDF)',
      cancel: 'Tühista',
      send: 'Saada',
      required: 'Kohustuslik',
      success: 'Sooviavaldus saadetud',
      close: 'Sulge teade',
      addFiles: 'Lisa faile',
    },
    askOffer: {
      close: 'Sulge teade',
      send: 'Kuldpaketi pakkumine saadetud',
      title: 'Palun jäta oma kontaktid, võtame Sinuga peagi ühendust',
      subtitle: 'Prooviperioodiga tuleb kaasa tasuta Infopanga demo, et saaksid kasutusest maksimumi võtta.',
      success: 'Sinu päring on teele pandud!',
      error: 'Tekkis probleem andmete saatmisel. Palun vaata väljad üle.',
      name: 'Ees- ja perekonnanimi',
      required: 'Kohustuslik',
      phone: 'Telefon',
      email: 'E-mail',
      info: 'Infovajadus',
      message: 'Sõnum',
      button: 'Saada',
      options: {
        credit: 'Taustainfo',
        marketing: 'Turundusnimekirjad',
        other: 'Muu',
        select: 'Vali kategooria',
      },
      validation: {
        wrongPhone: 'Vale number',
        wrongPhoneNumber: 'Ainult numbrid',
        wrongEmail: 'Vale e-maili formaat',
      },
    },
    breadcrumbs: {
      frontpage: 'Avaleht',
      search: 'Otsing',
      blog: 'Blogi',
      account: 'Konto',
    },
    article: {
      readMore: 'Loe lisaks',
    },
    controlMulti: {
      selectCategory: 'Vali kõik kategoorias',
    },
    companyChart: {
      allFilters: 'Kõik filtrid',
      showSecondStageRelations: 'Kuva 2. astme seosed',
      applyFilters: 'Kinnita filtrid',
      showBeneficiaries: 'Kuva kasusaajad',
    },
    notFound: {
      title: 'Soovitud lehte ei leitud',
      description: 'Otsitav lehekülg ei ole enam saadaval',
      back: 'Mine avalehele',
    },
    error: {
      title: 'Midagi läks valesti',
      description: 'Toimingu tegemine ebaõnnestus. Palun proovi hetke pärast uuesti.',
    },
    serverError: {
      title: 'Midagi läks valesti',
      description: 'Lehe laadimisel tekkis ootamatu viga. Palun proovige mõne aja pärast uuesti.',
    },
    moduleError: {
      title: 'Midagi läks valesti',
      description: 'Mooduli laadimisel tekkis ootamatu viga. Palun proovige mõne aja pärast uuesti.',
    },
    table: {
      showHistory: 'Näita ajalugu',
      hideHistory: 'Peida ajalugu',
    },
    paywall: {
      text: 'Krediidiraporti allalaadimiseks pead olema kuldpaketi kasutajana sisse logitud',
      addDebt: 'Võlanõude lisamiseks pead olema kuldpaketi kasutajana sisse logitud',
      monitoring: 'Ettevõtte seiresse lisamiseks pead olema kuldpaketi kasutajana sisse logitud',
      limitMonitoring:
        'Sinu seirenimekirja maht on täis. Kui vajad limiidi suurendamist, anna palun meile sellest märku aadressil <a href="mailto:info@infopank.ee">info@infopank.ee</a>',
      downloadLimit:
        'Sinu allalaadimiste limiit selleks kuuks on täis, kui soovid limiite muuta, kirjuta meile <a href="mailto:info@infopank.ee">info@infopank.ee</a>',
      button: 'Aktiveeri kuldpakett',
    },
    blog: {
      title: 'Blogi',
      button: 'Vaata kõiki blogi postitusi',
    },
    share: {
      email: 'E-mail',
      link: 'Link',
    },
  },
  company: {
    dataNotLoaded: 'Andmete laadimine ei õnnestunud',
    tryAgain: 'Proovi veel kord',
    addDebt: 'Lisa võlg',
    creditReport: 'Krediidiraport',
    creditReportExample: 'Vaata näidisraportit',
    removeMonitoring: 'Eemalda seirest',
    addMonitoring: 'Lisa seiresse',
    success: 'Korras!',
    removed: 'Ettevõte on seirest eemaldatud',
    added: 'Ettevõte on seiresse lisatud',
    news: 'Uudised',
    articleNews: 'Infoteated',
    noNews: 'Ettevõte pole esinenud Äripäeva uudistes',
    sections: {
      'general': 'Üldinfo',
      'business-relations': 'Äriseosed',
      'business-analytics': 'Ärianalüütika',
      'swot-analysis': 'SWOT-analüüs',
      'tax-report': 'Maksuraport',
      'debt-registry': 'Võlaregister',
      'other-info': 'Muu info',
    },
    pdf: {
      view: 'Vaata',
      download: 'Laadi alla',
    },
    chart: {
      connectionsLimit: 'Liiga palju äriseoseid graafiku koostamiseks. Palun korriegeeri tingimusi.',
    },
    businessAnalyticsComparison: {
      subtitle: 'Võrdle ettevõtte finantsnäitajaid teiste valitud ettevõtetega.',
      compareWith: 'Võrdle ettevõttega',
      searchPlaceholder: 'Otsi ettevõtet',
      inComparison: 'Võrdluses',
      clearComparison: 'Tühjenda võrdlus',
      removeFromComparison: 'Eemalda {{name}} võrdlusest',
      mainCompanyBadge: 'Põhiettevõte',
      quarterlyRevenue: 'Kvartali käive',
      employeeCount: 'Töötajate arv',
      revenuePerEmployee: 'Käive töötaja kohta',
      averageMonthlyWage: 'Keskmine kuutöötasu',
      loadingComparisonData: 'Võrdlusandmete laadimine...',
    },
    download: {
      result: '{{total}} otsingu tulemust',
      description:
        'NB! Kuvame tulemuses kuni {{maxRowsInExport}} kirjet. Palun täpsusta filtrite valikut. Faili läheb kuni {{maxRowsInExport}} kirjet. Palun täpsusta filtrite valikut.',
      limit: 'NB! Failide allalaadimiseks on vaja lubada brauseris pop-up aknad! Failide limiit: {{limit}} Kasutamata jääk: {{stock}}',
      save: 'Salvesta tulemused (.csv)',
    },
    filter: {
      personAudience: 'Võtmeisikute sihtrühm',
      companyAudience: 'Ettevõtete sihtrühm',
      relatedToPerson: 'Isikuga seotud ettevõtete filtrid',
      listOfCompanies: 'Koosta nimekiri ettevõtetest',
      viewAll: 'Vali kõik',
      keyPerson: 'Võtmeisikute filtrid',
      relationship: 'Seos ettevõttega',
      areaResponsibility: 'Vastutusvaldkond',
      belongs: 'Kuuluvus Äripäeva edetabelitesse',
      numberEmployee: 'Töötajate arv',
      from: 'Alates',
      to: 'Kuni',
      location: 'Asukoht',
      establishDate: 'Asutamise aeg',
      legalForm: 'Ettevõtte õiguslik vorm',
      profitLoss: 'Ärikasum / kahjum',
      fieldActivity: 'Tegevusala',
      searchFieldActivity: 'Sisesta otsitav tegevusala',
      revenue: 'Müügitulu',
    },
    creditReportComponent: {
      description:
        '<p>Krediidiraport sisaldab järgmist infot ning on väljaprinditav:</p><ul><li>Krediidireiting ja soovitatav krediidilimiit</li><li>Võlainfo: maksuvõlad, nõuded Infopanga võlaregistris, maksekäsud, täitmisteated, vara arestimised</li><li>Ettevõtte üldandmed, kontaktandmed</li><li>Vastutavad isikud (juhatus)</li><li>Muud seotud isikud (omanikud, nõukogu liikmed, asutaja, audiitor, võtmetöötajad)</li><li>Bilanss, kasumiaruanne ja rahavoogude aruanne viimasest saadaolevast aastaaruandest</li><li>Kvartaalsed majandustulemused: käive, töötajate arv, tasutud maksud</li><li>Seotud uudised ja kuulumine Äripäeva TOP-idesse</li></ul><p>Raport koostatakse reaalajas kõige uuemate andmete pealt. Palume kannatlikkust kuna raporti reaalajas koostamine võib võtta mõned sekundid.</p>',
    },
  },
  person: {
    noNews: 'Isik pole esinenud Äripäeva uudistes',
    sections: {
      'overview': 'Infokaart',
      'business-relations': 'Äriseosed',
      'work-history': 'Ametikäik',
      'news': 'Uudised',
    },
    table: {
      name: 'Nimi',
      birthday: 'Sünnikuupäev',
    },
  },
  account: {
    myAccount: 'Minu konto',
    monitoringCompanyList: 'Seiratavate nimekiri',
    monitoringEvents: 'Seiresündmused',
    companyName: 'Ettevõtte nimi',
    selfService: 'Iseteenindus',
    selfServiceDescription: 'Äripäeva iseteeninduses saad muuta oma konto andmeid, hallata tellimusi, lisada/eemaldada ligipääse jm.',
    selfServiceButton: 'Sisene iseteenindusse',
    noMonitoringEventsTitle: 'Teated ei leitud!',
    noMonitoringEventsDescription:
      'Kui oled lisanud enda jaoks olulised konkurendid, kliendid ja koostööpartnerid seiresse, siis just siit leiad tulevikus värsked teavitused nende ettevõtete kohta. Seireteated tulevad ka sinu e-mailile. Ettevõtte seiresse lisamiseks klõpsa ettevõtte vaates nuppu "Lisa seiresse".',
  },
  toaster: {
    success: 'Korras!',
    companyDeleted: 'Ettevõte on seirest eemaldatud',
    ip: 'Oled lugemisõigusega võrgus {{name}}. Palun logi sisse, et täismahus kõiki artikleid lugeda.',
    login: 'Logi sisse',
  },
  debtForm: {
    conditions: 'Nõustu tingimustega',
    details: 'Võlausaldaja andmed',
    error: 'Tekkis probleem andmete saatmisel. Palun vaata väljad üle.',
    required: 'Kohustuslik',
    name: 'Võlausaldaja nimi',
    registerCode: 'Võlausaldaja reg. kood',
    contact: 'Võlausaldaja kontaktisik',
    email: 'Võlausaldaja e-mail',
    phoneNumber: 'Võlausaldaja telefoninumber',
    debtDetails: 'Võlgniku andmed',
    debtName: 'Võlgniku nimi',
    debtRegisterCode: 'Võlgniku reg. kood',
    debtTime: 'Võla tekkimise aeg',
    debtTimeDescription: 'NB! Kui võlg koosneb mitmetest arvetest siis näiteks vanima arve maksetähtaeg.',
    debtSum: 'Võla summa',
    debtDocuments: 'Alusdokumendid',
    debtDocumentFormat: 'Lubatud formaadid: {{formats}}',
    paymentInfo: 'TÄHTIS! Kui peale võla lisamist klient arve ära tasub, andke sellest teada meilile',
    paymentInfoSecond: 'Siis märgitakse maksehäire registris lahendatuks.',
    agreement: {
      text: 'Nõustun maksehäirete avalikustamise <1>tingimustega</1> ja kinnitan, et võlgnevus on sissenõutav ning see pole vaidlustatud.',
      terms: 'tingimustega',
    },
    cancel: 'Tühista',
    send: 'Saada',
    addedDebt: 'Võlg lisatud',
    debtDeny: 'Võlanõude lisamiseks pead olema kuldpaketi kasutajana sisse logitud',
    activatePackage: 'Aktiveeri kuldpakett',
    paymentConditions: 'Maksehäirete avalikustamise tingimused',
    terms:
      '<p>Teenuse pakkuja – Äripäev AS</p><p>Klient – isik, kes soovib avalikustada enda Klientide võlgnevusi.</p><p>Kliendil on õigus sisestada Infopanka <a href="https://infopank.ee/">https://infopank.ee/</a> andmeid oma klientide maksehäirete kohta vastavalt Teenuse pakkuja poolt kehtestatud nõuetele ja korrale.</p><p>Maksehäire on Kliendi poolt rahalise kohustuse täitmata jätmine rohkem kui 30 (kolmkümmend) päeva arvates maksetähtpäevale järgnevast päevast. Enda klientide võlgnevuste edastamisega kinnitab Klient, et sisestatav maksehäire ei ole vaidlustatud (puuduvad vaidlused), võlgnevus on sissenõutav ja tõene.</p><p>Teenuse pakkujal on õigus keelduda maksehäire sisestamisest, enne maksehäire avalikustamist saadetakse selle kohta e-mailiga võlglasele teavitus. 7 päeva möödudes saadetakse võlglasele uus e-mail teavitusega, et maksehäire on avalikustatud.</p><p>Pretensioonid andmete õigsuse kohta esitatakse kirjalikult Teenuse pakkujale, kes edastab vastava pretensiooni vaidlustatud andmete sisestajale. Vaidlustatud andmete sisestaja kohustub hiljemalt 14 päeva jooksul pretensiooni lahendama, teatades sellest kirjalikult pretensiooni esitajale ning tehes vajadusel vastavad muudatused andmetesse. Teenuse pakkuja jätab endale õiguse põhjendatud vajaduse korral kustutada Kliendi poolt sisestatud andmed.</p><p>Klient vastutab edastatavate andmete õigsuse ja seaduslikkuse eest. Valeandmete levitamisega tekitatud kahju kuulub täies ulatuses hüvitamisele Kliendi poolt.</p><p>Teenuse pakkujal on õigus igal ajal piirata või tühistada Kliendi õigust sisestada Võlaregistrisse andmeid oma klientide/võlgnike maksehäirete kohta.</p><p>Teenuse pakkuja jätab endale õiguse teha muudatusi maksehäirete sisestamise korras ning vajadusel kehtestada selleks täiendavad tüüptingimused, mis avaldatakse veebilehel <a href="https://infopank.ee/">https://infopank.ee/</a> ning mis sellisel juhul Lepingu oluliseks osaks ning Kliendile täitmiseks kohustuslikud.</p>',
  },
  certificates: {
    congratulations: 'Õnnitleme!',
    sorry: 'Kontrolli tulemus',
    backButton: 'Tagasi',
    qualifies: '{{companyName}} kvalifitseerub järgnevatele sertifikaatidele:',
    notQualifies: '{{companyName}} ei kvalifitseeru kahjuks Infopanga sertifikaatidele.',
    order: 'Telli sertifikaadid',
    description: {
      html: '<p>Infopank väljastab silmapaistvatele, edukatele ja usaldusväärsetele ettevõtetele järgnevaid sertifikaate ja märgiseid:</p><ul><li>Äripäeva TOP ettevõte</li><li>Usaldusväärne ettevõte</li></ul>',
    },
    companyQualifies: 'Vaata, kas Sinu ettevõte kvalifitseerub sertifikaadile',
  },
  report: {
    extraDownload: {
      confirm: 'Nõustun',
      close: 'Sulge',
      description:
        'Sinu lepingus määratud tasuta allalaadimise limiit {{maxAllowed}} on ületatud. Iga järgnev allalaadimine maksab {{price}} eurot. Tasu lisatakse kuuarvele.',
    },
  },
  cookie: {
    preferences: 'Eelistuste haldamine',
  },
};

export default et;
